
<b-container
  v-if="(content.listePdf && content.listePdf['@nodes'].length > 0) || content.texteRegle"
  fluid
  class="d-flex justify-content-center m-0 px-0 px-md-4"
>
  <b-row class="w-100 bordure">
    <b-col
      cols="12"
      class="titre-liste graphik_black px-2 px-sm-4 px-md-0 px-lg-2"
      :class="{ zoneEscamotableCliquable: !$isMobile() }"
    >
      <div
        v-b-toggle="regleUid"
        class="texte-regles px-1 py-2 px-lg-0"
        @click="collapsed = !collapsed"
      >
        {{ $t('messageComponent.regle') }}
        <svg-icon
          :icon-name="collapsed ? 'icone-plus-pale' : 'icone-moins-pale'"
          class="icone ml-1"
        />
      </div>
    </b-col>

    <b-collapse :id="regleUid" visible class="regle-de-jeux container-collapse w-100">
      <div
        class="col-md-10 col-lg-8 mx-auto px-3 px-sm-5 p-md-3 pt-2"
        :class="{ 'col-xl-12': idFamille }"
      >
        <div v-if="content.texteRegle" v-html="content.texteRegle" />
        <template v-if="content.listePdf">
          <div
            v-for="(item, index) in content.listePdf['@nodes']"
            :key="item"
            :class="{ 'pb-3': content.listePdf['@nodes'].length !== index }"
          >
            <Hyperlien
              v-if="content.listePdf[item].pdf.metadata"
              class="themeClair"
              :content="getContentHyperlien(item)"
            />
          </div>
        </template>
      </div>
    </b-collapse>
  </b-row>
</b-container>
